<!--components\Boletas\CasillasOtp.vue-->
<template>
  <div class="flex flex-row justify-between">
    <input
      v-for="(digito, i) in modelValue"
      :key="i"
      :ref="el => (inputsRef[i] = el)"
      :value="digito"
      type="text"
      inputmode="numeric"
      maxlength="1"
      class="p-0 w-[2.8rem] h-[2.8rem] md:w-[3.4rem] md:h-[3.4rem] text-center text-xl font-bold text-black bg-gray-100 rounded-xl border-gray-300 focus:ring-0 focus:border-ROJO_TITULOS_LEON focus:ring-ROJO_TITULOS_LEON"
      @input="$emit('input-casilla', i, $event)"
      @keydown="$emit('keydown-casilla', i, $event)"
    />
  </div>
</template>

<script setup>
import { ref } from "vue";

defineProps({
  modelValue: { type: Array, required: true }, // 6 strings
});
defineEmits(["input-casilla", "keydown-casilla"]);

const inputsRef = ref([]);
defineExpose({
  focusCasilla: (i) => inputsRef.value[i]?.focus(),
});
</script>